import { faIcon } from "@utils/faIcon"

import { Icon } from "@atoms"

import styles from "./PopoverButton.module.scss"
import { PopoverButtonProps } from "./PopoverButton.types"

export default function PopoverButton(props: PopoverButtonProps) {
    const { children, onClick, icon, showChevron, isTabbable } = props
    return (
        <button className={styles.base} onClick={onClick} tabIndex={isTabbable ? 0 : -1}>
            <div className={styles.menuItemInnerContainer}>
                <div className={styles.iconAndText}>
                    <Icon icon={icon} size={14} />
                    <div className={styles.text}>{children}</div>
                </div>
                {showChevron && (
                    <div className={styles.chevron}>
                        <Icon icon={faIcon({ name: "angle-right", style: "regular" })} size={14} />
                    </div>
                )}
            </div>
        </button>
    )
}
